<!-- 上传方式选择 -->
<template>
  <div class="tips-block">
    <div class="flex-box">
      <div class="flex-1 fb-700">上传方式</div>
    </div>
    <el-divider />
    <div class="flex-box">
      <el-checkbox-group v-model="checkList" @change="checkBoxHandle">
        <el-checkbox label="1">拍照上传</el-checkbox>
        <el-checkbox label="2">相册选取</el-checkbox>
        <el-checkbox label="3">聊天记录选取</el-checkbox>
      </el-checkbox-group>
    </div>
  </div>
</template>

<script>
export default {
  name: "UploadSourceSelector",
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  computed: {
    checkList: {
      get() {
        return this.value ? this.value.split(",") : [];
      },
      set(val) {
        this.$emit("input", val.join(","));
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    checkBoxHandle(val) {
      this.$emit("input", val.join(","));
    },
  },
};
</script>

<style scoped lang="scss">
.tips-block {
  margin-top: 10px;
  background-color: #fff;
  padding: 10px 0;
}
.flex-box {
  display: flex;
  align-items: center;
  width: 100%;
  height: 45px;
  padding: 0 10px;
  box-sizing: border-box;
  background-color: #fff;
}
.flex-1 {
  flex: 1;
}
.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 5px 0;
}

.fb-700 {
  font-weight: 700;
}
label {
  margin-bottom: 0;
}
</style>
